<script>
import groupBy from "lodash/groupBy";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import { cloneDeep } from "lodash";
export default {
  props: {
    budgetline: {},
    deliveryUnit: {
      type: Number,
      default: null,
    },
    rowItem: {}
  },
  components: {
    MaskedInput
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 200,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterModal: "",
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
        // allowNegative: true,
      }),
      selectedOE: {
        id: 0,
        financeTemplateObjectOfExpenditureId: 0,
        isExclusive: false,
        deliveryUnitId: 0,
        amount: "0",
      },
      addedAmount: "0",
      toEdit: false,
      selectedBudgetLineItem: null,
      selectedBudgetLineItemModal: false,
      selectedBudgetLineItemResources: [],
      cycle: Number(this.$store.getters["data/getCycle"]),
      transferModal: false,
      selectedResourceBudgetItemId: 0,
      selectedResource: null,
      selectedFinanceBudgetItem: null,
    };
  },

  methods: {
    updateResource(data) {
      this.transferModal = true;
      this.selectedResourceBudgetItemId = data.financeTemplateBudgetItemId;
      this.selectedResource = data;
    },
    saveUpdateResource(data) {
      // if (this.selectedResource.total > data.balance) {
      //   this.showToast(
      //     "Insufficient budget. Cannot transfer because resources total is greater than budget item balance",
      //     "error"
      //   );
      //   return;
      // }
      this.$swal({
        title: "Are you sure?",
        html: `You are now transfering this resource to <span class="text-warning">${data.account}</span>. Do you want to continue?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28c76f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, transfer it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // this.transferModal = false;
          this.pageLoader(true);
          const newData = {
            id: this.selectedResource.id,
            prePlanningApiId: this.selectedResource.prePlanningApiId,
            financeTemplateBudgetItemId: data.id,
            itemName: this.selectedResource.itemName,
            description: this.selectedResource.description,
            unitId: this.selectedResource.unitId,
            type: this.selectedResource.type,
            isProcurable: this.selectedResource.isProcurable,
            isMixed: this.selectedResource.isMixed,
            subType: this.selectedResource.subType,
            cseId: this.selectedResource.cseId,
            itemCategoryId: this.selectedResource.itemCategoryId,
            unitCost: this.selectedResource.unitCost,
          };
          this.$store
            .dispatch("preplanningapiresource/UpdatePrePlanningApiResource", newData)
            .then(async (response) => {
              if (response.data.error) {
                this.showToast(response.data.error, "error");
                return;
              }
              /** Update Object of Expenditures here */
              if (this.selectedResource.financeTemplateBudgetItem) {
                const newOfficeBudget = {
                  id: data.id,
                  financeTemplateObjectOfExpenditureId:
                    data.financeTemplateObjectOfExpenditureId,
                  isExclusive: data.isExclusive,
                  deliveryUnitId: data.deliveryUnitId,
                  amount: data.amount + this.selectedResource.total,
                };
                const newOfficeBudgetRequest = await this.$store.dispatch(
                  "financeTemplate/updateTemplateBudgetItem",
                  newOfficeBudget
                );
                // this.selectedResource.financeTemplateBudgetItem.amount =
                if (newOfficeBudgetRequest.data.error) {
                  this.showToast(newOfficeBudgetRequest.data.errorMessage, "error");
                  return;
                }
                this.$emit("updateList", newOfficeBudget);
                const oldOfficeBudgetAmount = {
                  id: this.selectedResource?.financeTemplateBudgetItem.id,
                  financeTemplateObjectOfExpenditureId: this.selectedResource
                    ?.financeTemplateBudgetItem.financeTemplateObjectOfExpenditureId,
                  isExclusive: this.selectedResource?.financeTemplateBudgetItem
                    .isExclusive,
                  deliveryUnitId: this.selectedResource?.financeTemplateBudgetItem
                    .deliveryUnitId,
                  amount:
                    this.selectedResource?.financeTemplateBudgetItem.amount -
                    this.selectedResource.total,
                };
                const oldOfficeBudgetRequest = await this.$store.dispatch(
                  "financeTemplate/updateTemplateBudgetItem",
                  oldOfficeBudgetAmount
                );
                if (oldOfficeBudgetRequest.data.error) {
                  this.showToast(oldOfficeBudgetRequest.data.errorMessage, "error");
                  return;
                }
                this.selectedResource.financeTemplateBudgetItemId = data.id;
                this.selectedResource.financeTemplateBudgetItem =
                  newOfficeBudgetRequest.data;
                this.$emit("updateList", oldOfficeBudgetAmount);
              }

              this.$emit("updateOfficeBudget", {
                id: data.deliveryUnitId,
                budgetItemId: this.selectedResourceBudgetItemId,
                emit: true,
                budgetItem: this.selectedFinanceBudgetItem,
              });
              this.pageLoader(false);
              this.selectedResourceBudgetItemId = data.id;
              this.showToast("Resource updated successfully", "success");
            })
            .catch((error) => {
              this.showToast(
                "Error updating resource. Please contact your administrator",
                "error"
              );
            });
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },

    filterTable(row, filter) {
      if (
        row.financeTemplateObjectOfExpenditure.prexc.prexcName
          .toLowerCase()
          .includes(filter) ||
        row.financeTemplateObjectOfExpenditure.accountGroup.groupName
          .toLowerCase()
          .includes(filter)
      ) {
        return true;
      } else {
        return false;
      }
    },
    removeOE(data) {
      if (data.totalUsed > 0) {
        this.showToast(
          "Ooops! Object of Expenditure has been used. Cannot remove item ",
          "error"
        );
        return;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You are now removing this budget item. You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("financeTemplate/deleteBudgetItem", data.id)
            .then((response) => {
              if (response.data.error) {
                this.showToast(response.data.error, "error");
                return;
              }
              this.$emit("updateList", data);
              this.showToast("Budget item removed successfully", "success");
            })
            .catch((error) => {
              this.showToast("Error removing budget item", "error");
            });
        }
      });
    },
    updateAllocated(data) {
      this.selectedOE = {
        ...data,
        amount: data.amount.toString(),
      };
      this.$emit("toggleEdit", data);
    },
    hideModal() {
      this.addedAmount = "0";
      this.$bvModal.hide("amount-modal");
    },
    submitValue(row) {
      if (row.totalUsed > this.getExactAmt(row.amountString)) {
        this.pageLoader(false);
        return this.showToast(
          "Amount cannot be greater than the used amount",
          "error"
        );
      }
      this.pageLoader(true);
      const newData = cloneDeep(row);
      newData.amount = this.getExactAmt(newData.amountString);
      this.$store
        .dispatch("financeTemplate/updateTemplateBudgetItem", newData)
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.error, "error");
            return;
          }
          this.pageLoader(false);
          this.$emit("updateList", newData);
          this.$emit("toggleEdit", row);
          this.showToast("Budget item updated successfully", "success");
        })
        .catch((err) => {
          this.pageLoader(false);
          this.showToast("Error updating budget item", "error");
        });
    },
    toggleLock(data) {
      this.$store
        .dispatch("financeTemplate/updateIsLock", {
          ids: [data.id],
          isLock: !data.isLock,
        })
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.error, "error");
            return;
          }
          this.$emit("updateList", data);
          this.showToast("Budget item updated successfully", "success");
        })
        .catch((error) => {
          this.showToast("Error updating budget item", "error");
        });
    },
    markExclusive(data) {
      this.$store
        .dispatch("financeTemplate/updateIsExclusive", {
          ids: [data.id],
          isExclusive: !data.isExclusive,
        })
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.error, "error");
            return;
          }
          this.$emit("updateList", data);
          this.showToast("Budget item updated successfully", "success");
        })
        .catch((error) => {
          this.showToast("Error updating budget item", "error");
        });
    },
    viewResources(data, emit = false) {
      if (!emit) {
        data.rotateChevy = !data.rotateChevy;
      }
      this.selectedFinanceBudgetItem = data;
      data.isBudgetItemLoading = true;
      // this.selectedBudgetLineItemModal = true;
      /** Fetch BLI resources */
      if (data.rotateChevy) {
        this.$store
          .dispatch("planningapiresource/GetSimplePlanningApiResources", data.id)
          .then((response) => {
            if (response.data.error) {
              this.showToast(response.data.errorMessage, "error");
              return;
            }
            data.budgetItems = response.data;
            data.isBudgetItemLoading = false;
          })
          .catch((error) => {
            this.showToast(
              "Something went wrong. Fetching resources encountered error",
              "error"
            );
            data.isBudgetItemLoading = false;
            this.selectedBudgetLineItemModal = false;
          });
      }
    },
    calculateQuantity(data) {
      const total = data.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.quantity;
      }, 0);
      return total;
    },
    cancelEdit(row) {
      this.$emit('toggleEdit', row);
    }
  },
  computed: {
    rows() {
      return this.budgetline.length;
    },
    filteredBudget() {
      let data = this.budgetline;
      var total = this.currentPage * this.perPage;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.financeTemplateObjectOfExpenditure.accountGroup.groupName
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPageB > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      var groupedFC = groupBy(currentData, "fundClass");
      var grouped = [];
      for (const key in groupedFC) {
        grouped.push({
          id: groupedFC[key][0].financeTemplateObjectOfExpenditure.accountGroup.fundClassification.id,
          key: key,
          allowAdd: groupedFC[key][0].allowAdd,
          data: groupedFC[key],
        })
      }
      return grouped;
    },
    filteredBudgetForModal() {
      let data = this.budgetline;
      var total = this.currentPage * this.perPage;

      if (this.filterModal.trim() != "" && this.filterModal) {
        data = data.filter((item) => {
          return item.financeTemplateObjectOfExpenditure.accountGroup.groupName
            .toUpperCase()
            .includes(this.filterModal.toUpperCase());
        });
      }
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPageB > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rowsBudget() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filteredBudget.length;
      } else {
        return this.budgetline.length;
      }
    },
  },
  created() { },
};
</script>
<template>
  <div>
    <!-- modals -->
    <b-modal size="xl" title="Transfer Resource to Another Budget Item" v-model="transferModal" hide-footer>
      <div id="info" v-if="selectedResource">
        <div class="row">
          <div class="col-md-9">
            <p class="mb-1">
              <small class="d-block">API: </small>
              <strong class="text-yellow">{{ selectedResource.api }}</strong>
            </p>
            <p class="mb-1">
              <small class="d-block">Item: </small>
              <strong class="text-yellow">{{ selectedResource.itemName }}</strong>
            </p>
            <p class="mb-1">
              <small class="d-block">Description: </small>
              <span class="text-mute">{{ selectedResource.description }}</span>
            </p>
          </div>
          <div class="col-md-3 text-end">
            <p class="mb-0">
              <small class="d-block">Unit Cost: </small>
              <strong class="text-yellow">{{
                formatCurrency(selectedResource.unitCost)
              }}</strong>
            </p>
            <p class="mb-0">
              <small class="d-block">Quantity: </small>
              <strong class="text-yellow">{{
                selectedResource.prePlanningApiResourceDetails.length > 0
                  ? calculateQuantity(selectedResource.prePlanningApiResourceDetails)
                  : 0
              }}
                {{ selectedResource.unit ? selectedResource.unit.shortName : "" }}</strong>
            </p>
            <p class="mb-0">
              <small class="d-block">Total: </small>
              <strong class="text-info font-size-20">{{
                formatCurrency(selectedResource.total)
              }}</strong>
            </p>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12 text-end">
            <div id="tickets-table_filter" class="dataTables_filter me-1">
              <label class="d-inline-flex align-items-center">
                <b-form-input autocomplete="off" v-model="filterModal" type="search" placeholder="Search Budget..."
                  class="form-control"></b-form-input>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-table-responsive">
        <table class="table project-list-table table-centered table-borderless table-hover align-middle">
          <thead>
            <tr>
              <th scope="col" width="30px"></th>
              <th scope="col">Description</th>
              <th scope="col" class="text-center">Budget</th>
              <th scope="col" width="150px" class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="y in filteredBudgetForModal">
              <template v-for="z in y.data">
                <tr :key="'B' + z.id" style="background-color: transparent; box-shadow: none">
                  <td colspan="6" class="p-0-20p">
                    <div class="d-flex align-item-center">
                      <span class="bx bx-checkbox-square text-success me-1" style="line-height: unset"></span>
                      <b class="text-warning">{{ y.key }}</b>
                    </div>
                  </td>
                </tr>
                <template v-for="w in z.data">
                  <template v-for="x in w.data">
                    <tr style="background-color: transparent" :key="`data1-${x.id}`">
                      <td></td>
                      <td class="bg-table-tr">
                        <h5 class="text-truncate font-size-14 mb-0 d-flex">
                          {{ x.financeTemplateObjectOfExpenditure.accountGroup.groupName }}
                        </h5>
                        <p class="mb-0" v-if="x.financeTemplateObjectOfExpenditure.prexc">
                          <span class="badge rounded-pill badge-soft-info">{{
                            x.financeTemplateObjectOfExpenditure.prexc.uacs }}</span>
                          -
                          <small>{{ x.financeTemplateObjectOfExpenditure.prexc.prexcName }}</small>
                        </p>
                        <p class="mb-0" v-else>
                          <span>
                            <i class="mdi mdi-information-outline text-warning font-size-16 me-1"></i>
                            <em class="text-danger">Manually Added by Delivery Unit</em>
                          </span>
                        </p>
                      </td>
                      <td class="bg-table-tr">
                        <div class="d-flex flex-row flex-wrap justify-content-around">
                          <p class="mb-0">
                            <small class="d-block">Allocated:</small>
                            <span role="button" class="text-info">{{
                              formatCurrency(x.amount)
                            }}</span>
                          </p>
                          <p class="mb-0">
                            <small class="d-block">Used:</small>
                            <span class="text-success">{{
                              formatCurrency(x.totalUsed)
                            }}</span>
                          </p>
                          <p class="mb-0">
                            <small class="d-block">Remaining:</small>
                            <span class="text-warning">{{
                              formatCurrency(x.balance)
                            }}</span>
                          </p>
                        </div>
                      </td>
                      <td class="text-center">
                        <small v-if="x.id === selectedResourceBudgetItemId" class="text-warning">
                          Current
                        </small>
                        <span role="button" v-else @click="saveUpdateResource(x)" class="text-info">
                          <small class="align-middle">Transfer here</small>
                          <i class="bx bx-right-arrow-alt align-middle pointing-animation font-size-18"></i>
                        </span>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </b-modal>
    <b-modal id="amount-modal" title="Add Allocation" hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="d-flex justify-content-between">
        <p>
          <small class="d-block">Item of Expenditure: </small>
          <span class="text-info">{{ selectedOE.account }}</span>
        </p>
        <p>
          <small class="d-block">Amount: </small>
          <span class="text-info">{{ formatCurrency(selectedOE.amount) }}</span>
        </p>
      </div>
      <b-form-group label="Additional amount">
        <masked-input autocomplete="off" type="text" v-model="addedAmount" placeholder="Enter Amount..."
          class="form-control" :mask="currencyMask">
        </masked-input>
      </b-form-group>
    </b-modal>
    <!-- modals -->
    <div class="card border border-info">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 d-flex justify-content-between">
            <div id="tickets-table_filter" class="dataTables_filter me-1">
              <label class="d-inline-flex align-items-center">
                <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search Budget..."
                  class="form-control"></b-form-input>
              </label>
            </div>
            <div id="buttons" class="pt-2">
              <!-- <b-button variant="primary"
                        size="sm"
                        class="me-2"
                        @click="$emit('ppmp', deliveryUnit)">
                <i class="bx bx-printer me-2 align-middle font-size-16"></i> Print PPMP
              </b-button> -->
              <b-button variant="outline-primary" size="sm" class="me-2" @click="$emit('viewDetails', rowItem)">
                <i class="bx bx-plus-medical me-1 font-size-15 align-middle"></i>
                Add OOE
              </b-button>
              <b-button variant="success" size="sm" class="me-2" @click="$emit('opcr', deliveryUnit)"><i
                  class="bx bx-printer me-2 align-middle font-size-16"></i> Print
                OPCR</b-button>
              <b-button variant="info" size="sm" @click="$emit('lib', deliveryUnit)"><i
                  class="bx bx-printer me-2 align-middle font-size-16"></i> Print
                LIB</b-button>
            </div>
            <!-- <div id="tickets-table_length" class="dataTables_length">
                                                                                                                                                  <label class="d-inline-flex align-items-center mb-0">
                                                                                                                                                    <b-form-select
                                                                                                                                                      class="form-select"
                                                                                                                                                      v-model="perPage"
                                                                                                                                                      size="sm"
                                                                                                                                                      :options="pageOptions"
                                                                                                                                                    ></b-form-select>
                                                                                                                                                  </label>
                                                                                                                                                </div> -->
          </div>
        </div>
        <div>
          <div class="custom-table-responsive">
            <table class="table table-centered align-middle">
              <thead>
                <tr>
                  <th scope="col">Description</th>
                  <th scope="col" class="text-center">Budget</th>
                  <th scope="col" width="100px" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="budgetline.length == 0">
                  <td colspan="100%" class="text-center">
                    No data found...
                  </td>
                </tr>
                <template v-for="y in filteredBudget">
                  <tr :key="`A-${y.id}`">
                    <td colspan="100%">
                      <h5 class="mb-0"><span class="text-info">{{ y.key }}</span> <i
                          class="bx bx-check-circle text-success" title="Allow Delivery Unit to Add Account"
                          v-if="y.allowAdd"></i></h5>
                    </td>
                  </tr>
                  <template v-for="(x, xIndex) in y.data">
                    <tr :key="`data1-${y.id}-${x.id}`">
                      <td class="ps-5">
                        <h5 class="text-truncate font-size-14 mb-0 d-flex">
                          {{
                            x.financeTemplateObjectOfExpenditure.accountGroup.groupName
                          }}
                        </h5>
                        <div class="d-flex mt-1">
                          <div class="
                              form-check
                              form-checkbox-outline
                              form-check-success
                              mb-0
                              me-2
                              " v-if="xIndex == 0">
                            <input type="checkbox" :id="`allowAdd-${x.id}`" class="form-check-input"
                              v-model="x.allowAdd" :disabled="!x.forEdit" /><label :for="`allowAdd-${x.id}`"
                              class="form-check-label">
                              Allow Add
                            </label>
                          </div>
                          <!-- <div class="
                              form-check
                              form-checkbox-outline
                              form-check-warning
                              mb-0
                              me-2
                              " v-if="xIndex == 0">
                            <input type="checkbox" :id="`allowedToExceed-${x.id}`" class="form-check-input"
                              v-model="x.allowedToExceed" :disabled="!x.forEdit" /><label
                              :for="`allowedToExceed-${x.id}`" class="form-check-label">
                              Allow to Exceed Amount
                            </label>
                          </div> -->
                          <div class="
                              form-check
                              form-checkbox-outline
                              form-check-success
                              mb-0
                              ">
                            <input type="checkbox" id="customCheckcolor2" checked="checked" class="form-check-input"
                              v-model="x.allowTransfer" :disabled="!x.forEdit" /><label for="customCheckcolor2"
                              class="form-check-label">
                              Allow Transfer
                            </label>
                          </div>
                        </div>
                        <p class="mt-1 mb-0">
                          <span role="button" class="font-size-8 text-yellow align-middle" @click="viewResources(x)">
                            View Resources
                            <i class="bx bx-caret-right rotate font-size-16 cursor-pointer align-middle" :class="{
                              'rotate-90': x.rotateChevy,
                            }"></i>
                          </span>
                        </p>
                      </td>
                      <td class="bg-table-tr">
                        <div class="d-flex flex-row flex-wrap justify-content-around">
                          <p class="mb-0">
                            <small class="d-block">Allocated:</small>
                            <span class="text-info" title="Click to add funds" v-if="!x.forEdit">{{
                              formatCurrency(x.amount) }}
                            </span>
                            <span v-else>
                              <masked-input autocomplete="off" type="text" v-model="x.amountString"
                                placeholder="Enter Amount..." class="form-control form-control-sm w-75 d-inline"
                                :mask="currencyMask">
                              </masked-input>
                            </span>
                          </p>
                          <p class="mb-0">
                            <small class="d-block">Used:</small>
                            <span class="text-success">{{
                              formatCurrency(x.totalUsed)
                            }}</span>
                          </p>
                          <p class="mb-0">
                            <small class="d-block">Remaining:</small>
                            <span class="text-warning">{{
                              formatCurrency(x.balance)
                            }}</span>
                          </p>
                        </div>
                      </td>
                      <td class="text-center">
                        <span role="button" class="me-1" @click="updateAllocated(x)" v-if="!x.forEdit">
                          <i class="bx bx-edit font-size-18 text-success"></i>
                        </span>
                        <span role="button" @click="submitValue(x)" v-if="x.forEdit">
                          <i class="bx bx-check font-size-20"></i>
                        </span>
                        <span role="button" @click="cancelEdit(x)" v-if="x.forEdit">
                          <i class="bx bx-x font-size-20 text-danger"></i>
                        </span>
                        <span role="button" @click="removeOE(x)" v-if="!x.forEdit">
                          <i class="bx bx-trash font-size-18 text-danger"></i>
                        </span>
                      </td>
                    </tr>
                    <tr v-if="x.rotateChevy" :key="`second-tr-${x.id}`">
                      <td colspan="3">
                        <div id="loading" v-if="x.isBudgetItemLoading">
                          <div class="d-flex justify-content-center align-items-center pt-1 mt-1">
                            <div class="preloader-component me-3">
                              <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                  <div class="chase-dot"></div>
                                  <div class="chase-dot"></div>
                                  <div class="chase-dot"></div>
                                  <div class="chase-dot"></div>
                                  <div class="chase-dot"></div>
                                  <div class="chase-dot"></div>
                                </div>
                              </div>
                            </div>
                            <strong>Fetching necessary data. Thank you for your patience...</strong>
                          </div>
                        </div>

                        <div id="content" v-else>
                          <div class="alert alert-info alert-dismissible fade show mb-0"
                            v-if="x.budgetItems.length == 0" role="alert">
                            <i class="mdi mdi-alert-circle-outline me-2"></i>
                            This budget line item has no resources yet...
                          </div>
                          <div v-else>
                            <table class="table table-bordered mb-0">
                              <thead class="table-light">
                                <tr>
                                  <th class="" width="20px"></th>
                                  <th class="text-center " width="60px">Quantity</th>
                                  <th class="">Item</th>
                                  <th class="text-center ">Cost</th>
                                  <th class="text-center ">Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-for="api in x.budgetItems">
                                  <tr :key="`API-${api.id}`">
                                    <td colspan="100%" class="font-weight-bold text-white">{{ api.api }}</td>
                                  </tr>
                                  <template v-for="w in api.planningApiResources">
                                    <tr :key="`Items-${api.id}${w.id}`">
                                      <td></td>
                                      <td class="text-center">{{ w.quantity }}</td>
                                      <td>{{ w.itemName }}</td>
                                      <td class="text-center">{{ formatCurrency(w.unitCost) }}</td>
                                      <td class="text-center">{{ formatCurrency(w.total) }}</td>
                                    </tr>
                                  </template>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.v-enter-active {
  transition: all 0.3s ease-out;
}

.v-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.v-enter-from,
.v-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
